// extracted by mini-css-extract-plugin
export default {"productimg":"show_productimg__xp1Ck","productdiv":"show_productdiv__6BdM9","producttitle":"show_producttitle__M5wFK","productprice":"show_productprice__YPiew"};